import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsConcourseComponent } from './simple-icons-concourse.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsConcourseComponent ],
    exports:      [ SimpleIconsConcourseComponent ],
    bootstrap:    []
})
export class SimpleIconsConcourseModule {}
